import { Injectable} from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  public isNative: boolean = Capacitor.isNativePlatform();

  putDataInStorage(storageKey:any, storageData:any){
    const finalStorageKey = (storageKey === 'access_token' && this.isNative ? 'm_access_token' : storageKey);
    localStorage.setItem(finalStorageKey, storageData);
  }
  getDataFromStorage(storageKey:any){
    const finalStorageKey = (storageKey === 'access_token' && this.isNative ? 'm_access_token' : storageKey);
    return localStorage.getItem(finalStorageKey);
  }
  
  removeDataFromStorage(storageKey:any){
    const finalStorageKey = (storageKey === 'access_token' && this.isNative ? 'm_access_token' : storageKey);
    return localStorage.removeItem(finalStorageKey);
  }

  clearStorage(){
    localStorage.clear();
  }
}
